
import BookingBasketHeadDetail from "@/components/booking/basket/BookingBasketHeadDetail.vue";
import BookingBasketSection from "@/components/booking/basket/BookingBasketSection.vue";
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import { DirectionEnum, ModeOfTravelEnum } from "@/models/enums";
import { useBookingSummaryStore } from "@/store/basket";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent, ref } from "vue";
import BookingBasketExtras from "@/components/booking/basket/BookingBasketExtras.vue";
import BaseExpansion from "@/components/base/BaseExpansion.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { useMediaQuery } from "@vueuse/core";
import BaseSvg from "@/components/base/BaseSvg.vue";
import { useRoute } from "vue-router";

export default defineComponent({
	props: {
		renderBasketContainer: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	components: {
		BookingBasketHeadDetail,
		BookingBasketSection,
		BookingBasketExtras,
		BaseSpinner,
		BaseExpansion,
		BaseButton,
		BaseSvg,
		BaseAlert
	},
	setup() {
		const bookingStore = useBookingStore();
		const bookingSummaryStore = useBookingSummaryStore();
		const loading = computed(() => bookingSummaryStore.getLoading);
		const route = useRoute();
		const isLargeScreen = useMediaQuery("(min-width: 779.99px)");
		const largeScreen = computed(() => {
			return isLargeScreen.value;
		});

		const expanded = ref(false);

		const bookingSections = computed(() => {
			if (bookingSummaryStore.getBookingSummary?.bookingSections?.length > 0) {
				return bookingSummaryStore.getBookingSummary.bookingSections;
			}

			return [];
		});

		const hasReturnDirection = computed(() => {
			return bookingStore.getBooking.tripType === DirectionEnum.Return;
		});

		const bookingSummary = computed(() => {
			return bookingSummaryStore.getBookingSummary;
		});

		const toggle = () => {
			expanded.value = !expanded.value;
		};

		const modeOfTravel = computed(() => {
			return ModeOfTravelEnum[bookingStore.getBooking.modeOfTravel];
		});

		const tripType = computed(() => {
			return DirectionEnum[bookingStore.getBooking.tripType];
		});

		const displayDetailedPayment = computed(() => {
			return (["5", "6"].includes(route.query.step as string) && bookingSummary.value.paid > 0);
		});

		const displayCalculatePaymentAlert = computed(() => {
			return !["5", "6"].includes(route.query.step as string) && bookingStore.getBooking.amendmentMode;
		})

		return {
			bookingSummary,
			DirectionEnum,
			bookingSections,
			hasReturnDirection,
			loading,
			expanded,
			toggle,
			largeScreen,
			modeOfTravel,
			tripType,
			displayDetailedPayment,
			displayCalculatePaymentAlert
		};
	},
});
